import React, {useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmSignUp } from './authService';
import { Form, Input, Button, message} from 'antd';

type FieldType = {
  email?: string;
  confirmationCode?: string;
};

const ConfirmUserPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [email, setEmail] = useState(location.state?.email || ''); 
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: { confirmationCode: string }) => {
    try {
      await confirmSignUp(email, values.confirmationCode);
      messageApi.success("Account confirmed successfully! Please sign in.");
      setTimeout(() => navigate('/login'), 3000); // Delays navigation by 3 seconds
    } catch (error: unknown) {
      if (error instanceof Error) {
        // More specific error handling based on the error name or message
        switch (error.name) {
          case 'UsernameExistsException':
            messageApi.error("User already exists. Please sign in or use a different email.");
            break;
          case 'CodeMismatchException':
            messageApi.error("Invalid confirmation code provided. Please try again.");
            break;
          case 'ExpiredCodeException':
            messageApi.error("The confirmation code has expired. Please request a new code.");
            break;
          case 'LimitExceededException':
            messageApi.error("Attempt limit exceeded, please try after some time.");
            break;
          default:
            messageApi.error(error.message || "Failed to confirm account due to an unknown error.");
        }
      } else {
        messageApi.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  return (
    <div className="loginForm">
      <h2>Confirm Account</h2>
      {contextHolder}
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item<FieldType>
          name="email"
          label="Email"
          initialValue={email}
          rules={[{ required: true, type: 'email', message: 'Please input your Email!' }]}
        >
          <Input placeholder="Email" disabled onChange={(e) => setEmail(e.target.value)}/>
        </Form.Item>
        <Form.Item<FieldType>
          name="confirmationCode"
          rules={[{ required: true, message: 'Please input your confirmation code!' }]}
        >
          <Input placeholder="Confirmation Code"/>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Confirm Account
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ConfirmUserPage;
